import {message} from "antd";
import React, {useEffect, useState} from "react";

//182.61.34.119:8081
const backendApiAddress = "182.61.34.119:8090";
const frontEndAddress = "182.61.34.119:8081";
const fileAddress = "182.61.34.119:8081";

let ApiAddress
let JsonData
let DataReturned

export function getFileAddress(){
    return fileAddress
}


export function getFrontEndAddress(){
    return frontEndAddress
}

export function getHostAddress(){
    return backendApiAddress
}

export function setApiAddress(value){
    ApiAddress = value
}

export function getApiAddress(){
    return ApiAddress
}

export function setJsonData(value){
    JsonData = value
}

export function getJsonData(value){
    return JsonData
}

export function isNull(value){
    //如果值没有意义  或 为空 返回True  否则返回false
    if (value === null || value === undefined || value === ""){
        return true
    }
    return false
}

export function setDataReturned(value){
    //global.constants.DataReturned= value
    //window.localStorage.setItem("DataReturned", value);
    console.log("setDataReturned  --------fun ")
    //console.log(global.constants.DataReturned)
    DataReturned = value
}

export function getDataReturned(){
    console.log("------getDataReturned--------------")
    //console.log(global.constants.DataReturned)
    //return global.constants.DataReturned
    //return window.localStorage.g("DataReturned", value);
    return DataReturned
}

export function mainSet(value){
    //setApiAddress(value.address)
    //setJsonData(value.json)
    ApiAddress = value.address
    JsonData = value.json
    connectionBackend()
    return DataReturned
}

export function connectionBackend(){

        console.log("HostAddress:"+getHostAddress())
        console.log("ApiAddress:"+getApiAddress())
        console.log(getJsonData())

        // if (!isNull(getHostAddress())){
        //     return null
        // }
        // if (!isNull(getApiAddress())){
        //     return null
        // }
        // if (!isNull(getJsonData())){
        //     return null
        // }
        fetch(
            "http://"+getHostAddress()+getApiAddress(),
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify(getJsonData()),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setDataReturned(data)
                //console.log("getDataReturned:")
                //console.log(getDataReturned())
                //DataReturned = data
            })
            .catch(error => message.error("error"+error));

        return true
}
